/**
 * Created by koqiui on 2017-04-09.
 */
import { Vue } from '../../app.vues'
import { Utils } from '../../app.base'

//
import merchtAllApi from '../../api/merchtAll'
import SwbMerchantBizRelSelect from './MerchantBizRelSelect.vue';
Vue.regist(SwbMerchantBizRelSelect);

export function showComAuditorSelectDlg(dlgArgs, callback, thisArg) {
    dlgArgs = dlgArgs || {};
    callback = callback || null;
    thisArg = thisArg || null;
    //
    let useUserId = dlgArgs['useUserId'] || false;
    let useDesc = dlgArgs['useDesc'] !== false;
    let auditorId = dlgArgs['auditorId'] || null;
    let applyDesc = dlgArgs['applyDesc'] || '';
    //
    let theDlg = Vue.$showDialog({
        title: "选择审核人",
        width: 480,
        centerButtons: true,
        height: useDesc ? 300 : 240,
        cancelVisible: true,
        okVisible: true,
        template: '\
            <div>\
                <div class="form-row spacing">\
                    <div class="form-label">\
                        <label>指定审核人</label>\
                    </div>\
                    <div class="form-value width-1-5x">\
                        <el-select v-if="useUserId" placeholder="- 请选择 -" class="fl" v-model="auditorId">\
                            <el-option v-for="staff in staffList" :key="staff.name" :label="staff.name" :value="staff.userId"></el-option>\
                        </el-select>\
                        <el-select v-else placeholder="- 请选择 -" class="fl" v-model="auditorId">\
                            <el-option v-for="staff in staffList" :key="staff.name" :label="staff.name" :value="staff.id"></el-option>\
                        </el-select>\
                    </div>\
                </div>\
                <div v-if="useDesc" class="form-row spacing">\
                    <div class="form-label">\
                        <label>申请审核描述</label>\
                    </div>\
                    <div class="form-value width-1-5x">\
                        <el-input type="textarea" v-model="applyDesc"></el-input>\
                    </div>\
                </div>\
            </div>',
        data: {
            //是否使用staff.userId 而不是 staff.id
            useUserId: useUserId,
            useDesc: useDesc,
            //
            auditorId: auditorId,
            applyDesc: applyDesc,
            //
            staffList: []
        },
        lifecycle: {
            created: function () {
                let self = this;
                //
                merchtAllApi.getComAuditorListByContext({}, function (result) {
                    if(result.type == 'info') {
                        self.staffList = result.data || [];
                    }
                });
            }
        },

        okClicked: function () {
            let resultData = {
                auditorId: this.auditorId
            };
            if(this.useDesc) {
                resultData.applyDesc = this.applyDesc;
            }
            //
            var idProp = this.useUserId ? 'userId' : 'id';
            if(resultData.auditorId != null) {
                let theOne = this.staffList.find(function (item) {
                    return item[idProp] == resultData.auditorId;
                });
                if(theOne != null) {
                    resultData.auditorName = theOne.name;
                }
            }
            //
            if(typeof callback == "function") {
                return callback.apply(thisArg, [resultData]);
            }
        }
    });
};

// 选择（具有操作权限的）岗位（比如：选择审核岗位） //actionPostId
// 可用参数：{ title（对话框标题）, rescUrl, action, initPostId（回显）, useParents,  useDesc, descLabel, applyDesc（回显）}
// 返回数据：{postId, postName, departId, departName, comId, comName, comLevel, descLabel, applyDesc}
import SwbComActionPostSelect from './ComActionPostSelect'

Vue.regist(SwbComActionPostSelect);

//
export function showComActionPostSelectDlg(dlgArgs, callback, thisArg) {
    thisArg = thisArg || null;
    callback = callback || null;
    dlgArgs = dlgArgs || {};
    //------------------------------------------------
    let title = dlgArgs['title'] || "选择操作岗位";
    //
    let rescUrl = dlgArgs['rescUrl'] || null;
    let action = dlgArgs['action'] || null;
    let initPostId = dlgArgs['initPostId'] || null;
    let useParents = dlgArgs['useParents'] || false;
    //是否使用 描述
    let useDesc = dlgArgs['useDesc'] !== false;
    //附加描述 标签文字（默认为：附加描述）
    let descLabel = dlgArgs['descLabel'] || '附加描述';
    //附加描述 初始内容
    let applyDesc = dlgArgs['applyDesc'] || '';
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 800,
        centerButtons: true,
        height: useDesc ? 800 : 600,
        cancelVisible: true,
        okVisible: true,
        template: '\
            <div>\
                <div class="form-row spacing">\
                    <div class="form-label">\
                        <label>操作岗位</label>\
                    </div>\
                    <div class="form-value width-3x ">\
                        <swb-com-action-post-select ref="com_action_post_select_comp" :rescUrl="rescUrl" :action="action" :initPostId="initPostId" :useParents="useParents" ></swb-com-action-post-select>\
                    </div>\
                </div>\
                <div v-if="useDesc" class="form-row spacing">\
                    <div class="form-label">\
                        <label>{{descLabel}}</label>\
                    </div>\
                    <div class="form-value width-3x">\
                        <el-input type="textarea" v-model="applyDesc"></el-input>\
                    </div>\
                </div>\
            </div>',
        data: {
            rescUrl: rescUrl,
            action: action,
            initPostId: initPostId,
            useParents: useParents,
            //
            useDesc: useDesc,
            descLabel: descLabel,
            applyDesc: applyDesc
        },
        lifecycle: {
            created: function () {

            }
        },

        okClicked: function () {
            let resultData = {};
            //岗位数据
            let com_action_post_select_comp = this.$refs['com_action_post_select_comp'];
            let postResultData = com_action_post_select_comp.getResultData();
            if(postResultData.postId == null) {
                Toast.show('请选择操作岗位！', 3000, 'warning');
                return false;
            }
            resultData = Utils.merge(resultData, postResultData);
            //描述数据
            if(this.useDesc) {
                resultData.descLabel = this.descLabel;
                resultData.applyDesc = this.applyDesc;
            }
            //
            if(typeof callback == "function") {
                return callback.apply(thisArg, [resultData]);
            }
        }
    });

}

// 审核对话框
// 可用参数：{ title（对话框标题）, subject（审核主题）, applyDesc（提交申请时的描述）, auditRecList(审核记录 [auditState, auditTime, auditorName, auditDesc]), showFinalAudit（是否显示终审选项）, auditLabels(['通过', '不通过'])
// selectNextPost（是否选择下一岗位）, nextPostParams(下一操作岗位信息{ rescUrl, action, useParents) }
// 返回数据：{auditState, auditDesc, finalAudit(true/false), nextPostResultData({postId, postName, departId, departName, comId, comName, comLevel}) }
export function showBizAuditDlg(dlgArgs, callback, thisArg) {
    thisArg = thisArg || null;
    callback = callback || null;
    dlgArgs = dlgArgs || {};
    //------------------------------------------------
    let title = dlgArgs['title'] || "审核";
    //
    let subject = dlgArgs['subject'] || '请给出您的审核意见';
    let applyDesc = dlgArgs['applyDesc'] || null;
    let auditRecList = dlgArgs['auditRecList'] || null;
    let showFinalAudit = dlgArgs['showFinalAudit'] || false;
    let auditLabels = dlgArgs['auditLabels'] || ['通过', '不通过'];
    //
    let selectNextPost = dlgArgs['selectNextPost'] || false;
    let nextPostParams = dlgArgs['nextPostParams'] || null;
    let dlgHeight = showFinalAudit ? 800 : 500;
    dlgHeight += applyDesc != null ? 100 : 0;
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 800,
        centerButtons: true,
        height: dlgHeight,
        cancelVisible: true,
        okVisible: true,
        template: '\
            <div>\
                <div class="content-caption dashed bg-white">\
                    <span>{{subject}}</span>\
                </div>\
                <div v-if="applyDesc != null" class="form-row spacing">\
                    <div class="form-label">\
                        <label>申请描述</label>\
                    </div>\
                    <div class="form-value width-3x">\
                        <p style="color:darkgray">{{applyDesc}}</p>\
                    </div>\
                </div>\
                <div class="form-row spacing">\
                    <div class="form-label">\
                        <label>意见</label>\
                    </div>\
                    <div class="form-value width-3x">\
                        <el-radio-group v-model="auditState" @change="synAuditDescLabel">\
                            <el-radio :label="auditOptions.AuditPass">{{auditLabels[0]}}</el-radio>\
                            <el-radio :label="auditOptions.AuditFail">{{auditLabels[1]}}</el-radio>\
                        </el-radio-group>\
                        <el-checkbox v-show="showFinalAudit && auditState == auditOptions.AuditPass" class="ml15" v-model="finalAudit" >本次审核为终审</el-checkbox>\
                    </div>\
                </div>\
                <div class="form-row spacing">\
                    <div class="form-label">\
                        <label v-if = "auditState == auditOptions.AuditFail" class="required">{{auditDescLabel}}</label>\
                        <label v-else>{{auditDescLabel}}</label>\
                    </div>\
                    <div class="form-value width-3x">\
                        <el-input type="textarea" v-model="auditDesc"></el-input>\
                    </div>\
                </div>\
                <div v-if="selectNextPost && !finalAudit && auditState == auditOptions.AuditPass" class="form-row spacing">\
                    <div class="form-label">\
                        <label>下一操作岗位</label>\
                    </div>\
                    <div class="form-value width-3x ">\
                        <swb-com-action-post-select ref="com_action_post_select_comp" :rescUrl="nextPostParams.rescUrl" :action="nextPostParams.action" :useParents="nextPostParams.useParents" ></swb-com-action-post-select>\
                    </div>\
                </div>\
            </div>',
        data: {
            //审核选项
            auditOptions: {
                AuditPass: 1,
                AuditFail: -1
            },
            auditDescLabels: ['附加说明', '原因说明'],
            auditDescLabel: '说明/原因',
            //
            subject: subject,
            applyDesc: applyDesc,
            auditRecList: auditRecList,
            showFinalAudit: showFinalAudit,
            auditLabels: auditLabels,
            //
            selectNextPost: selectNextPost,
            nextPostParams: nextPostParams,
            //
            auditState: null,
            auditDesc: '',
            finalAudit: false
        },
        lifecycle: {
            created: function () {

            }
        },
        methods: {
            synAuditDescLabel: function (value) {
                if(value == this.auditOptions.AuditFail) {
                    this.auditDescLabel = this.auditDescLabels[1];
                }
                else {
                    this.auditDescLabel = this.auditDescLabels[0];
                }
            }
        },
        okClicked: function () {
            let resultData = {};
            //
            if(this.auditState == null) {
                Toast.show('请选择审核意见 ！', 3000, 'warning');
                return false;
            }
            resultData.auditState = this.auditState;

            //
            this.auditDesc = this.auditDesc.trim();
            if(this.auditState == this.auditOptions.AuditFail && this.auditDesc == '') {
                Toast.show('请给出 ' + this.auditDescLabel + ' ！', 3000, 'warning');
                return false;
            }
            resultData.auditDesc = this.auditDesc;

            //
            if(this.showFinalAudit) {
                resultData.finalAudit = this.finalAudit;
            }

            //
            if(this.selectNextPost && !this.finalAudit && this.auditState == this.auditOptions.AuditPass) {
                //岗位数据
                let com_action_post_select_comp = this.$refs['com_action_post_select_comp'];
                let postResultData = com_action_post_select_comp.getResultData();
                if(postResultData.postId == null) {
                    Toast.show('请选择下一操作岗位！', 3000, 'warning');
                    return false;
                }
                resultData.nextPostResultData = postResultData;
            }

            //
            if(typeof callback == "function") {
                return callback.apply(thisArg, [resultData]);
            }
        }
    });

}

import SwbMsgList from '../msg/MsgList';

Vue.regist(SwbMsgList);

/**
 *
 * @param isVoucher
 * @param group
 * @param fieldx
 * @param fieldy
 * @param receiverData [
 * * voucherChildType    -- 单据子类型  ps ： contract.getTypeId()
 * * currentPostIds       -- 内部岗位Ids信息
 * * currentMerchtType    -- 内部商户类型
 * * otherPostIds        -- 对外岗位Ids
 * * otherMerchtType       -- 对外商户类型
 * ]
 */
export function showMsgDlg(isVoucher, group, fieldx, fieldy, receiverData) {
    Vue.$showDialog({
        title: '站内信',
        showCloseBtn: true,
        width: '90%',
        height: '90%',
        template: '<div>' +
        '<swb-msg-list :isVoucher="isVoucher" :group="group" :fieldx="fieldx" :fieldy="fieldy" :receiverData="receiverData"></swb-msg-list>' +
        '</div>',
        data: {
            isVoucher: isVoucher,
            group: group,
            fieldx: fieldx,
            fieldy: fieldy,
            receiverData: receiverData
        },
        methods: {},
        okClicked: function () {

        },
        lifecycle: {}
    });
}

export function selectMerchantBizRelSelect(dlgArgs, callback) {
    dlgArgs = dlgArgs || {};
    callback = callback || null;
    //
    let checkBox = dlgArgs['checkBox'] || false;
    let propMerchantType = dlgArgs['propMerchantType'];
    let peerMerchantIds = dlgArgs['peerMerchantIds'] || [];
    Vue.$showDialog({
        title: '商户业务 - 关系',
        width: 900,
        height: 700,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-merchant-biz-rel-select :checkBox = "checkBox" :propMerchantType="propMerchantType" :peerMerchantIds="peerMerchantIds" ref="swb_merchant_biz_rel_select"></swb-merchant-biz-rel-select>' +
        '</div>',
        data: {
            checkBox: checkBox,
            propMerchantType: propMerchantType,
            peerMerchantIds: peerMerchantIds,
        },
        okClicked: function () {
            let result = this.$refs.swb_merchant_biz_rel_select.getDlgResult() || {};
            if(result.type === 'info') {
                let resultDate = result.data;
                callback(resultDate);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {

        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/merchant/showSelectDlg.js
// module id = 55
// module chunks = 1